import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ec66c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "flex flex-row items-center text-sm border-b border-black-border mainTab mt-2" }, [
  /*#__PURE__*/_createElementVNode("li", { role: "presentation" }, [
    /*#__PURE__*/_createElementVNode("button", { class: "text-gray-text p-3 hover:text-white active" }, "Environment")
  ])
], -1))
const _hoisted_3 = { class: "lg:grid lg:grid-cols-2 xl:grid-cols-3" }
const _hoisted_4 = { class: "xl:col-span-2 lg:mr-1.5 mb-3 bg-black-body" }
const _hoisted_5 = { class: "bg-black-sidebar px-2 py-0" }
const _hoisted_6 = { class: "flex items-center text-md text-gray-text" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-test-net mr-2 display-block relative top-0.5\" data-v-3ec66c90><span class=\"path1\" data-v-3ec66c90></span><span class=\"path2\" data-v-3ec66c90></span><span class=\"path3\" data-v-3ec66c90></span><span class=\"path4\" data-v-3ec66c90></span></span>", 1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-main-net mr-2 display-block relative top-0.5\" data-v-3ec66c90><span class=\"path1\" data-v-3ec66c90></span><span class=\"path2\" data-v-3ec66c90></span><span class=\"path3\" data-v-3ec66c90></span><span class=\"path4\" data-v-3ec66c90></span></span>", 1)
const _hoisted_9 = { class: "tablet:px-3 lg:pl-1.5 lg:pr-0 mb-3" }
const _hoisted_10 = { class: "bg-black-body text-white text-md h-full flex flex-col" }
const _hoisted_11 = { class: "p-7 pt-3 flex-grow" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5 text-xl" }, "Help Center", -1))
const _hoisted_13 = { class: "card-body mt-0" }
const _hoisted_14 = { class: "item-faq" }
const _hoisted_15 = {
  key: 0,
  class: "text-gray-text my-3 mb-8"
}
const _hoisted_16 = { class: "item-faq" }
const _hoisted_17 = {
  key: 0,
  class: "text-gray-text my-3 mb-8"
}
const _hoisted_18 = { class: "text-gray-text list-outside" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "inline-block mt-3" }, [
    /*#__PURE__*/_createElementVNode("div", null, "1. Sirius mobile wallet"),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-outside list-square ml-9" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Download Sirius Testnet mobile wallet and create your account"),
      /*#__PURE__*/_createElementVNode("li", null, "Connect it with Developers Dashboard")
    ])
  ])
], -1))
const _hoisted_20 = { class: "inline-block mt-3" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("2. ")
const _hoisted_22 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://bctestnetwallet.xpxsirius.io/",
  target: "_blank"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Sirius testnet web wallet ")
const _hoisted_24 = { class: "list-outside list-square flex flex-col ml-9" }
const _hoisted_25 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/onboarding/account_setup",
  target: "_blank"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Import your account from mobile wallet to web wallet ")
const _hoisted_27 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/onboarding/register_namespace",
  target: "_blank"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Registering your Namespace (your Game) ")
const _hoisted_29 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/onboarding/create_asset",
  target: "_blank"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Create your Asset (your Game Token) ")
const _hoisted_31 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/onboarding/link_to_namespace",
  target: "_blank"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Link your Asset to your Namepace ")
const _hoisted_33 = { class: "item-faq" }
const _hoisted_34 = {
  key: 0,
  class: "text-gray-text my-3 mb-8"
}
const _hoisted_35 = { class: "item-faq" }
const _hoisted_36 = {
  key: 0,
  class: "text-gray-text my-3 mb-8"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-black-footer p-7 text-gray-text flex-none" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://t.me/+vLFl6mYFsAcwNzY1",
    class: "text-blue-primary text-sm mr-1 inline-block",
    target: "_blank"
  }, "Learn more from our help center"),
  /*#__PURE__*/_createElementVNode("i", { class: "ml-1 xr-icon-new-tab relative top-0.5" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_homeConnectTestnetWalletComponent = _resolveComponent("homeConnectTestnetWalletComponent")!
  const _component_homeConnectMainnetWalletComponent = _resolveComponent("homeConnectMainnetWalletComponent")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", {
                class: _normalizeClass(["px-4 py-3 text-white", _ctx.currentOpenedTab == 'testnet'?'bg-black-body':'cursor-pointer']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentOpenedTab = 'testnet'))
              }, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.testnetLabel) + " Environment ", 1)
              ], 2),
              (_ctx.enableMainnet)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: _normalizeClass(["px-4 py-3 text-white", _ctx.currentOpenedTab == 'mainnet'?'bg-black-body':'cursor-pointer']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentOpenedTab = 'mainnet'))
                  }, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.mainnetLabel) + " Environment ", 1)
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.currentOpenedTab == 'testnet')
            ? (_openBlock(), _createBlock(_component_homeConnectTestnetWalletComponent, {
                key: 0,
                networkLabel: "Testnet",
                class: "p-7 gameDetailForm"
              }))
            : (_openBlock(), _createBlock(_component_homeConnectMainnetWalletComponent, {
                key: 1,
                networkLabel: "Mainnet",
                class: "p-7 gameDetailForm"
              }))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "text-gray-400 cursor-pointer mb-3 font-semibold",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.q1=!_ctx.q1))
                  }, "What is Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet?", 1),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.q1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Your ProximaX Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet is the wallet you will be using to have your game tested and by using " + _toDisplayString(_ctx.testnetLabel) + " XPX which is the ProximaX native token and has no real value to create your game ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "text-gray-400 cursor-pointer mb-3 font-semibold",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.q2=!_ctx.q2))
                  }, " How to create my own Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet? ", 1),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.q2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", null, "Both Sirius " + _toDisplayString(_ctx.testnetLabel) + " mobile and web wallets are required in this process", 1),
                            _createElementVNode("ul", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", null, [
                                    _hoisted_21,
                                    _createElementVNode("a", _hoisted_22, [
                                      _hoisted_23,
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "fa-solid fa-arrow-up-right-from-square",
                                        class: "ml-1"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("ul", _hoisted_24, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("a", _hoisted_25, [
                                        _hoisted_26,
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "fa-solid fa-arrow-up-right-from-square",
                                          class: "ml-1"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("a", _hoisted_27, [
                                        _hoisted_28,
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "fa-solid fa-arrow-up-right-from-square",
                                          class: "ml-1"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("a", _hoisted_29, [
                                        _hoisted_30,
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "fa-solid fa-arrow-up-right-from-square",
                                          class: "ml-1"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("a", _hoisted_31, [
                                        _hoisted_32,
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "fa-solid fa-arrow-up-right-from-square",
                                          class: "ml-1"
                                        })
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "text-gray-400 cursor-pointer mb-3 font-semibold",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.q3=!_ctx.q3))
                  }, " What is Sirius " + _toDisplayString(_ctx.mainnetLabel) + " Wallet? ", 1),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.q3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Your ProximaX Sirius " + _toDisplayString(_ctx.mainnetLabel) + " Wallet is the wallet you will be using once your game is published. You will be using tokens, NFTs of real value and " + _toDisplayString(_ctx.mainnetLabel) + " XPX which has real value. You can use this wallet once after you have received feedback from the testers who would have tried out your game on " + _toDisplayString(_ctx.testnetLabel) + ". ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", {
                    class: "text-gray-400 cursor-pointer mb-3 font-semibold",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.q4=!_ctx.q4))
                  }, " What is Sirius " + _toDisplayString(_ctx.testnetLabel) + " Faucet? ", 1),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.q4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, " This is the website where you can go to send the " + _toDisplayString(_ctx.testnetLabel) + " version of ProximaX's native token called XPX which has no real value. You can only have an account balance to a maximum of 100,000 " + _toDisplayString(_ctx.testnetLabel) + " XPX every 24 hours. ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_37
          ])
        ])
      ])
    ])
  ]))
}